<template>
  <transition name="fade">
    <div v-if="active" class="mega-menu__overlay" :style="height"></div>
  </transition>
</template>

<script>
  export default {
    name: 'MegaMenuOverlay',
    props: {
      active: Boolean
    },
    computed: {
      height() {
        return `height:${ document.body.scrollHeight }px;`
      }
    },
  }
</script>

<style lang="scss" scoped>
  div {
    position: absolute;
    width: 100%;
    background: rgba(0,0,0,.6);
    z-index: 1000;
  }

  .fade-enter-active, 
  .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, 
  .fade-leave-to{
    opacity: 0;
  }
</style>
